import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BoulderDetailsPage} from '../boulder-details/boulder-details.page';
import {BoulderListEntry} from '../../model/boulder-list-entry';
import {ModalController} from '@ionic/angular';
import {BoulderService} from '../../services/boulder.service';
import {SortBoulderListPipe} from '../../pipes/sort-boulder-list.pipe';
import {BBStorage} from '../../utils/bb-storage';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-definition-list',
  templateUrl: './definition-list.page.html',
  styleUrls: ['./definition-list.page.scss'],
})
export class DefinitionListPage implements OnInit {

  username: string;
  boulders: BoulderListEntry[] = [];

  constructor(
    private bbStorage: BBStorage,
    private modalCtrl: ModalController,
    private boulderService: BoulderService,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.username = this.activatedRoute.snapshot.paramMap.get('username');
    this.reloadBoulders();
  }

  private async reloadBoulders() {
    this.boulders = (await firstValueFrom(this.boulderService.getBouldersListEntries$())).filter(b => b.author == this.username);
    SortBoulderListPipe.sortBoulderList(this.boulders, this.bbStorage.boulderListSortType);
  }

  async showBoulder(boulderId: string) {
    const modal = await this.modalCtrl.create({
      component: BoulderDetailsPage,
      componentProps: {boulderId: boulderId, boulderIds: this.boulders.map(b => b.boulderId)}
    });
    return await modal.present();
  }

}
